/**
 * Runtime configuration. In dev, Vite proxies `/v1` and the WebSocket to the
 * relay, so same-origin defaults work. Override with VITE_RELAY_HTTP /
 * VITE_RELAY_WS for a split deployment.
 */
const httpBase = import.meta.env.VITE_RELAY_HTTP ?? "";

function wsBase(): string {
  if (import.meta.env.VITE_RELAY_WS) return import.meta.env.VITE_RELAY_WS;
  const loc = window.location;
  const proto = loc.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${loc.host}`;
}

export const config = {
  /** Base for REST calls, e.g. "" (same origin) or "https://relay.example.com". */
  httpBase,
  /** Base for the WebSocket, e.g. "wss://relay.example.com". */
  get wsUrl(): string {
    return `${wsBase()}/v1/socket`;
  },
  restUrl(path: string): string {
    return `${httpBase}${path}`;
  },
} as const;
